// Import and re-export from shared
export { priceWithCurrency } from 'tf-checkout-shared'

export const emptyPhone = (phone: string): string | undefined =>
  phone.length < 4 ? undefined : phone
